module.exports = __webpack_public_path__ + "img/ye.dd6dffd4.png";